

























import { Component } from 'vue-property-decorator';
import HomeSection from '../Home/Section.abstract';

@Component
export default class AboutSection extends HomeSection {
  textsAppearence = true;

  textsRefs = {
    textTop: 'textTop',
    textBottom: 'textBottom',
  };
}
